import { isSeason, DEFAULT_GAME_SEASON } from '@src/theme/season';
import type { BoxTheme } from '@lub0v/santa-utils';
import { NEW_BOX_STEPS, type NewBoxDraft, type NewBoxStep } from './draft';
export const newBoxDraftKey = (key: string) => `ss:new-box:draft:${key}`;
type SavedDraft = { draft: NewBoxDraft; previewTheme?: BoxTheme; step: NewBoxStep; editingThemeFromReview: boolean; questionnaireDefaults: string | null; userId: number | null; at: number };
const documentEntryKey = typeof window === 'undefined' ? null : window.history.state?.key ?? 'default';
/** Reload recovery is tab-local; opening a new game normally still starts fresh. */
export function reloadedNewBoxDraftKey(entryKey: string): string | null {
  try {
    if (entryKey !== documentEntryKey) return null;
    const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
    return navigation?.type === 'reload' ? sessionStorage.getItem('ss:new-box:current') : null;
  } catch { return null; }
}
export function readNewBoxDraft(userId: number | null, key: string): SavedDraft | null {
  try {
    const value = JSON.parse(localStorage.getItem(newBoxDraftKey(key)) || 'null') as SavedDraft | null;
    if (value && value.draft?.key === key && value.userId === userId && value.at <= Date.now() && Date.now() - value.at < 24 * 60 * 60 * 1000
      && NEW_BOX_STEPS.includes(value.step) && typeof value.draft?.key === 'string'
      && typeof value.draft.name === 'string' && typeof value.draft.organizerName === 'string'
      && Array.isArray(value.draft.participantNames)) return {
        ...value,
        draft: { ...value.draft, theme: isSeason(value.draft.theme) ? value.draft.theme : DEFAULT_GAME_SEASON },
        previewTheme: value.previewTheme && isSeason(value.previewTheme) ? value.previewTheme : undefined,
      };
  } catch { /* Missing or invalid draft. */ }
  return null;
}
export function saveNewBoxDraft(value: Omit<SavedDraft, 'at'>): void {
  if (!value.draft.key) return;
  try {
    localStorage.setItem(newBoxDraftKey(value.draft.key), JSON.stringify({ ...value, at: Date.now() }));
    sessionStorage.setItem('ss:new-box:current', value.draft.key);
  } catch { /* Storage may be unavailable. */ }
}
export function clearNewBoxDraft(key: string): void {
  try { localStorage.removeItem(newBoxDraftKey(key)); } catch { /* Storage may be unavailable. */ }
}
